import React from 'react';
import PropTypes from 'prop-types';
import './icons.scss';

export function CalenderPlusIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 3.83398C5.06065 3.83398 4.83398 3.60732 4.83398 3.33398V1.33398C4.83398 1.06065 5.06065 0.833984 5.33398 0.833984C5.60732 0.833984 5.83398 1.06065 5.83398 1.33398V3.33398C5.83398 3.60732 5.60732 3.83398 5.33398 3.83398Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
      <path
        d="M10.666 3.83398C10.3927 3.83398 10.166 3.60732 10.166 3.33398V1.33398C10.166 1.06065 10.3927 0.833984 10.666 0.833984C10.9393 0.833984 11.166 1.06065 11.166 1.33398V3.33398C11.166 3.60732 10.9393 3.83398 10.666 3.83398Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
      <path
        d="M5.66667 9.66753C5.58 9.66753 5.49333 9.6542 5.41333 9.6142C5.33333 9.58087 5.26 9.53419 5.19333 9.47419C5.07333 9.34752 5 9.17419 5 9.00086C5 8.91419 5.02 8.82752 5.05333 8.74752C5.08667 8.66752 5.13333 8.5942 5.19333 8.52753C5.26 8.46753 5.33333 8.42085 5.41333 8.38752C5.65333 8.28752 5.95334 8.34086 6.14 8.52753C6.2 8.5942 6.24667 8.66752 6.28 8.74752C6.31333 8.82752 6.33333 8.91419 6.33333 9.00086C6.33333 9.17419 6.26 9.34752 6.14 9.47419C6.01334 9.59419 5.84 9.66753 5.66667 9.66753Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
      <path
        d="M8.00065 9.66658C7.82732 9.66658 7.65398 9.59324 7.52731 9.47324C7.46731 9.40658 7.42065 9.33325 7.38732 9.25325C7.35399 9.17325 7.33398 9.08658 7.33398 8.99992C7.33398 8.82658 7.40731 8.65325 7.52731 8.52659C7.71398 8.33992 8.00732 8.27991 8.25399 8.38657C8.33399 8.41991 8.40732 8.46659 8.47399 8.52659C8.59399 8.65325 8.66732 8.82658 8.66732 8.99992C8.66732 9.08658 8.65398 9.17325 8.61398 9.25325C8.58065 9.33325 8.53399 9.40658 8.47399 9.47324C8.40732 9.53324 8.33399 9.57992 8.25399 9.61326C8.17399 9.65326 8.08732 9.66658 8.00065 9.66658Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
      <path
        d="M5.66667 11.9996C5.58 11.9996 5.49333 11.9796 5.41333 11.9463C5.33333 11.9129 5.26 11.8663 5.19333 11.8063C5.07333 11.6796 5 11.5129 5 11.3329C5 11.2463 5.02 11.1596 5.05333 11.0796C5.08667 10.9929 5.13333 10.9263 5.19333 10.8596C5.26 10.7996 5.33333 10.7529 5.41333 10.7196C5.65333 10.6129 5.95334 10.6729 6.14 10.8596C6.2 10.9263 6.24667 10.9929 6.28 11.0796C6.31333 11.1596 6.33333 11.2463 6.33333 11.3329C6.33333 11.5129 6.26 11.6796 6.14 11.8063C6.01334 11.9263 5.84 11.9996 5.66667 11.9996Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
      <path
        d="M13.6673 6.56055H2.33398C2.06065 6.56055 1.83398 6.33388 1.83398 6.06055C1.83398 5.78721 2.06065 5.56055 2.33398 5.56055H13.6673C13.9407 5.56055 14.1673 5.78721 14.1673 6.06055C14.1673 6.33388 13.9407 6.56055 13.6673 6.56055Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
      <path
        d="M12.0007 15.8333C10.254 15.8333 8.83398 14.4133 8.83398 12.6667C8.83398 10.92 10.254 9.5 12.0007 9.5C13.7473 9.5 15.1673 10.92 15.1673 12.6667C15.1673 14.4133 13.7473 15.8333 12.0007 15.8333ZM12.0007 10.5C10.8073 10.5 9.83398 11.4733 9.83398 12.6667C9.83398 13.86 10.8073 14.8333 12.0007 14.8333C13.194 14.8333 14.1673 13.86 14.1673 12.6667C14.1673 11.4733 13.194 10.5 12.0007 10.5Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
      <path
        d="M12.9933 13.2002H11C10.7267 13.2002 10.5 12.9735 10.5 12.7002C10.5 12.4269 10.7267 12.2002 11 12.2002H12.9933C13.2667 12.2002 13.4933 12.4269 13.4933 12.7002C13.4933 12.9735 13.2733 13.2002 12.9933 13.2002Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
      <path
        d="M12 14.2199C11.7267 14.2199 11.5 13.9932 11.5 13.7199V11.7266C11.5 11.4532 11.7267 11.2266 12 11.2266C12.2733 11.2266 12.5 11.4532 12.5 11.7266V13.7199C12.5 13.9932 12.2733 14.2199 12 14.2199Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
      <path
        d="M10.2467 15.1673H5.33333C2.9 15.1673 1.5 13.7673 1.5 11.334V5.66732C1.5 3.23398 2.9 1.83398 5.33333 1.83398H10.6667C13.1 1.83398 14.5 3.23398 14.5 5.66732V10.9073C14.5 11.114 14.3733 11.3006 14.1733 11.374C13.98 11.4473 13.76 11.394 13.62 11.234C13.2067 10.7673 12.6133 10.5007 11.9933 10.5007C10.8 10.5007 9.82667 11.474 9.82667 12.6673C9.82667 13.0607 9.93334 13.4473 10.14 13.7807C10.2533 13.9807 10.4 14.1473 10.56 14.2873C10.72 14.4206 10.78 14.6407 10.7067 14.8407C10.6467 15.034 10.46 15.1673 10.2467 15.1673ZM5.33333 2.83398C3.42667 2.83398 2.5 3.76065 2.5 5.66732V11.334C2.5 13.2407 3.42667 14.1673 5.33333 14.1673H9.21334C8.96667 13.714 8.83333 13.2007 8.83333 12.6673C8.83333 10.9207 10.2533 9.50065 12 9.50065C12.5267 9.50065 13.0467 9.63399 13.5 9.88066V5.66732C13.5 3.76065 12.5733 2.83398 10.6667 2.83398H5.33333Z"
        fill={color !== '' ? color : '#1D3E69'}
      />
    </svg>
  );
}
CalenderPlusIcon.propTypes = {
  color: PropTypes.string,
};
CalenderPlusIcon.defaultProps = {
  color: '',
};
export function CalenderCorrecttickIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 3.83398C5.06065 3.83398 4.83398 3.60732 4.83398 3.33398V1.33398C4.83398 1.06065 5.06065 0.833984 5.33398 0.833984C5.60732 0.833984 5.83398 1.06065 5.83398 1.33398V3.33398C5.83398 3.60732 5.60732 3.83398 5.33398 3.83398Z"
        fill={color}
      />
      <path
        d="M10.666 3.83398C10.3927 3.83398 10.166 3.60732 10.166 3.33398V1.33398C10.166 1.06065 10.3927 0.833984 10.666 0.833984C10.9393 0.833984 11.166 1.06065 11.166 1.33398V3.33398C11.166 3.60732 10.9393 3.83398 10.666 3.83398Z"
        fill={color}
      />
      <path
        d="M5.66667 9.66679C5.49333 9.66679 5.32 9.59345 5.19333 9.47345C5.07333 9.34679 5 9.18012 5 9.00012C5 8.91346 5.02 8.82679 5.05333 8.74679C5.08667 8.66679 5.13333 8.59346 5.19333 8.5268C5.44 8.28013 5.88667 8.28013 6.14 8.5268C6.26 8.65346 6.33333 8.82679 6.33333 9.00012C6.33333 9.04012 6.32667 9.0868 6.32 9.13347C6.31334 9.17347 6.3 9.21346 6.28 9.25346C6.26667 9.29346 6.24667 9.33346 6.22 9.37346C6.19333 9.40679 6.16667 9.44012 6.14 9.47345C6.01333 9.59345 5.84 9.66679 5.66667 9.66679Z"
        fill={color}
      />
      <path
        d="M8.00065 9.66753C7.91398 9.66753 7.82732 9.64753 7.74732 9.6142C7.66065 9.58087 7.59398 9.53419 7.52732 9.47419C7.40732 9.34752 7.33398 9.18086 7.33398 9.00086C7.33398 8.91419 7.35399 8.82752 7.38732 8.74752C7.42065 8.66752 7.46732 8.5942 7.52732 8.52753C7.59398 8.46753 7.66065 8.42085 7.74732 8.38752C7.99399 8.28752 8.28732 8.34086 8.47398 8.52753C8.59398 8.6542 8.66732 8.82753 8.66732 9.00086C8.66732 9.04086 8.66065 9.08753 8.65399 9.1342C8.64732 9.1742 8.63398 9.2142 8.61398 9.2542C8.60065 9.2942 8.58065 9.33419 8.55399 9.37419C8.53399 9.40752 8.50065 9.44085 8.47398 9.47419C8.34732 9.59419 8.17398 9.66753 8.00065 9.66753Z"
        fill={color}
      />
      <path
        d="M5.66667 11.9995C5.58 11.9995 5.49334 11.9795 5.41334 11.9462C5.32667 11.9129 5.25333 11.8662 5.19333 11.8062C5.13333 11.7462 5.08667 11.6729 5.05333 11.5862C5.02 11.5062 5 11.4195 5 11.3329C5 11.2462 5.02 11.1595 5.05333 11.0795C5.08667 10.9929 5.13333 10.9195 5.19333 10.8595C5.25333 10.7995 5.32667 10.7529 5.41334 10.7195C5.57334 10.6529 5.76 10.6462 5.92 10.7195C6.00666 10.7529 6.08 10.7995 6.14 10.8595C6.2 10.9195 6.24667 10.9929 6.28 11.0795C6.31333 11.1595 6.33333 11.2462 6.33333 11.3329C6.33333 11.4195 6.31333 11.5062 6.28 11.5862C6.24667 11.6729 6.2 11.7462 6.14 11.8062C6.08 11.8662 6.00666 11.9129 5.92 11.9462C5.84 11.9795 5.75333 11.9995 5.66667 11.9995Z"
        fill={color}
      />
      <path
        d="M13.6673 6.56055H2.33398C2.06065 6.56055 1.83398 6.33388 1.83398 6.06055C1.83398 5.78721 2.06065 5.56055 2.33398 5.56055H13.6673C13.9407 5.56055 14.1673 5.78721 14.1673 6.06055C14.1673 6.33388 13.9407 6.56055 13.6673 6.56055Z"
        fill={color}
      />
      <path
        d="M12.0007 15.8333C11.2207 15.8333 10.4807 15.5533 9.91399 15.04C9.67399 14.84 9.46065 14.5867 9.28732 14.2933C8.99398 13.8133 8.83398 13.2467 8.83398 12.6667C8.83398 10.92 10.254 9.5 12.0007 9.5C12.9073 9.5 13.774 9.89332 14.374 10.5733C14.8873 11.16 15.1673 11.9 15.1673 12.6667C15.1673 13.2467 15.0073 13.8133 14.7073 14.3C14.1473 15.2467 13.1073 15.8333 12.0007 15.8333ZM12.0007 10.5C10.8073 10.5 9.83398 11.4733 9.83398 12.6667C9.83398 13.06 9.94065 13.4467 10.1473 13.78C10.2607 13.98 10.4073 14.1467 10.5673 14.2867C10.9673 14.6467 11.4673 14.8333 12.0007 14.8333C12.7673 14.8333 13.4606 14.44 13.854 13.7867C14.0606 13.4467 14.1673 13.0667 14.1673 12.6667C14.1673 12.1467 13.974 11.64 13.6273 11.2333C13.214 10.7667 12.6207 10.5 12.0007 10.5Z"
        fill={color}
      />
      <path
        d="M11.6202 13.8257C11.4936 13.8257 11.3669 13.779 11.2669 13.679L10.6069 13.0191C10.4136 12.8257 10.4136 12.5057 10.6069 12.3124C10.8002 12.1191 11.1202 12.1191 11.3136 12.3124L11.6336 12.6324L12.7002 11.6457C12.9002 11.4591 13.2202 11.4724 13.4069 11.6724C13.5936 11.8724 13.5802 12.1924 13.3802 12.3791L11.9602 13.6924C11.8602 13.7791 11.7402 13.8257 11.6202 13.8257Z"
        fill={color}
      />
      <path
        d="M10.2467 15.1673H5.33333C2.9 15.1673 1.5 13.7673 1.5 11.334V5.66732C1.5 3.23398 2.9 1.83398 5.33333 1.83398H10.6667C13.1 1.83398 14.5 3.23398 14.5 5.66732V10.9073C14.5 11.114 14.3733 11.3006 14.1733 11.374C13.98 11.4473 13.76 11.394 13.62 11.234C13.2067 10.7673 12.6133 10.5007 11.9933 10.5007C10.8 10.5007 9.82667 11.474 9.82667 12.6673C9.82667 13.0607 9.93333 13.4473 10.14 13.7807C10.2533 13.9807 10.4 14.1473 10.56 14.2873C10.72 14.4206 10.78 14.6407 10.7067 14.8407C10.6467 15.034 10.46 15.1673 10.2467 15.1673ZM5.33333 2.83398C3.42667 2.83398 2.5 3.76065 2.5 5.66732V11.334C2.5 13.2407 3.42667 14.1673 5.33333 14.1673H9.21333C8.96667 13.714 8.83333 13.2007 8.83333 12.6673C8.83333 10.9207 10.2533 9.50065 12 9.50065C12.5267 9.50065 13.0467 9.63399 13.5 9.88066V5.66732C13.5 3.76065 12.5733 2.83398 10.6667 2.83398H5.33333Z"
        fill={color}
      />
    </svg>
  );
}
CalenderCorrecttickIcon.propTypes = {
  color: PropTypes.string,
};
CalenderCorrecttickIcon.defaultProps = {
  color: '#1D3E69',
};
export function CalenderEditIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 3.83398C5.06065 3.83398 4.83398 3.60732 4.83398 3.33398V1.33398C4.83398 1.06065 5.06065 0.833984 5.33398 0.833984C5.60732 0.833984 5.83398 1.06065 5.83398 1.33398V3.33398C5.83398 3.60732 5.60732 3.83398 5.33398 3.83398Z"
        fill={color}
      />
      <path
        d="M10.666 3.83398C10.3927 3.83398 10.166 3.60732 10.166 3.33398V1.33398C10.166 1.06065 10.3927 0.833984 10.666 0.833984C10.9393 0.833984 11.166 1.06065 11.166 1.33398V3.33398C11.166 3.60732 10.9393 3.83398 10.666 3.83398Z"
        fill={color}
      />
      <path
        d="M5.66667 9.66692C5.58 9.66692 5.49333 9.64693 5.41333 9.6136C5.32666 9.58027 5.26001 9.53358 5.19334 9.47358C5.07334 9.34692 5 9.17359 5 9.00026C5 8.82692 5.07334 8.6536 5.19334 8.52693C5.26001 8.46693 5.33333 8.42025 5.41333 8.38691C5.57333 8.32025 5.76 8.32025 5.92 8.38691C6 8.42025 6.07333 8.46693 6.13999 8.52693C6.16666 8.56026 6.19999 8.59359 6.21999 8.62692C6.24666 8.66692 6.26668 8.70692 6.28001 8.74692C6.30001 8.78692 6.31334 8.82691 6.32001 8.86691C6.32667 8.91358 6.33333 8.96026 6.33333 9.00026C6.33333 9.17359 6.25999 9.34692 6.13999 9.47358C6.07333 9.53358 6 9.58027 5.92 9.6136C5.84 9.64693 5.75333 9.66692 5.66667 9.66692Z"
        fill={color}
      />
      <path
        d="M8.00065 9.66679C7.91398 9.66679 7.82731 9.6468 7.74731 9.61347C7.66065 9.58013 7.59399 9.53345 7.52732 9.47345C7.40732 9.34679 7.33398 9.17346 7.33398 9.00012C7.33398 8.96012 7.34064 8.91345 7.34731 8.86678C7.35398 8.82678 7.36731 8.78679 7.38731 8.74679C7.40064 8.70679 7.42066 8.66679 7.44733 8.62679C7.47399 8.59346 7.50066 8.56013 7.52732 8.5268C7.77399 8.28013 8.22065 8.28013 8.47398 8.5268C8.50065 8.56013 8.52731 8.59346 8.55398 8.62679C8.58064 8.66679 8.60066 8.70679 8.61399 8.74679C8.63399 8.78679 8.64732 8.82678 8.65399 8.86678C8.66066 8.91345 8.66732 8.96012 8.66732 9.00012C8.66732 9.17346 8.59398 9.34679 8.47398 9.47345C8.34731 9.59345 8.18065 9.66679 8.00065 9.66679Z"
        fill={color}
      />
      <path
        d="M5.66667 11.9999C5.58 11.9999 5.49333 11.9799 5.41333 11.9466C5.33333 11.9133 5.26001 11.8666 5.19334 11.8066C5.07334 11.6799 5 11.5066 5 11.3333C5 11.2933 5.00666 11.2466 5.01333 11.2066C5.01999 11.1599 5.03332 11.1199 5.05332 11.0799C5.06666 11.0399 5.08668 10.9999 5.11334 10.9599C5.13334 10.9266 5.16667 10.8933 5.19334 10.8599C5.26001 10.7999 5.33333 10.7533 5.41333 10.7199C5.57333 10.6533 5.76 10.6533 5.92 10.7199C6 10.7533 6.07333 10.7999 6.13999 10.8599C6.16666 10.8933 6.19999 10.9266 6.21999 10.9599C6.24666 10.9999 6.26668 11.0399 6.28001 11.0799C6.30001 11.1199 6.31334 11.1599 6.32001 11.2066C6.32667 11.2466 6.33333 11.2933 6.33333 11.3333C6.33333 11.5066 6.25999 11.6799 6.13999 11.8066C6.07333 11.8666 6 11.9133 5.92 11.9466C5.84 11.9799 5.75333 11.9999 5.66667 11.9999Z"
        fill={color}
      />
      <path
        d="M13.6673 6.56055H2.33398C2.06065 6.56055 1.83398 6.33388 1.83398 6.06055C1.83398 5.78721 2.06065 5.56055 2.33398 5.56055H13.6673C13.9407 5.56055 14.1673 5.78721 14.1673 6.06055C14.1673 6.33388 13.9407 6.56055 13.6673 6.56055Z"
        fill={color}
      />
      <path
        d="M10.547 15.1871C10.2937 15.1871 10.0537 15.0937 9.88036 14.9204C9.6737 14.7137 9.58036 14.4137 9.62703 14.1004L9.7537 13.2004C9.78703 12.9671 9.92704 12.6871 10.0937 12.5204L12.4537 10.1604C12.7737 9.84039 13.087 9.67372 13.427 9.64039C13.847 9.60039 14.2537 9.77372 14.6404 10.1604C15.047 10.5671 15.5937 11.3937 14.6404 12.3471L12.2804 14.7071C12.1137 14.8737 11.8337 15.0137 11.6004 15.0471L10.7004 15.1737C10.647 15.1804 10.6004 15.1871 10.547 15.1871ZM13.5404 10.6337C13.5337 10.6337 13.527 10.6337 13.5204 10.6337C13.427 10.6404 13.3004 10.7271 13.1604 10.8671L10.8004 13.2271C10.7804 13.2471 10.747 13.3137 10.747 13.3404L10.627 14.1737L11.4604 14.0537C11.487 14.0471 11.5537 14.0137 11.5737 13.9937L13.9337 11.6337C14.227 11.3404 14.267 11.1937 13.9337 10.8604C13.827 10.7604 13.6737 10.6337 13.5404 10.6337Z"
        fill={color}
      />
      <path
        d="M13.9471 12.8336C13.9004 12.8336 13.8537 12.8269 13.8137 12.8136C12.9337 12.5669 12.2337 11.867 11.9871 10.987C11.9137 10.7203 12.067 10.4469 12.3337 10.3669C12.6004 10.2936 12.8737 10.447 12.9537 10.7136C13.107 11.2603 13.5404 11.6936 14.0871 11.8469C14.3537 11.9203 14.507 12.2003 14.4337 12.467C14.367 12.687 14.1671 12.8336 13.9471 12.8336Z"
        fill={color}
      />
      <path
        d="M8 15.1673H5.33333C2.9 15.1673 1.5 13.7673 1.5 11.334V5.66732C1.5 3.23398 2.9 1.83398 5.33333 1.83398H10.6667C13.1 1.83398 14.5 3.23398 14.5 5.66732V8.00065C14.5 8.27398 14.2733 8.50065 14 8.50065C13.7267 8.50065 13.5 8.27398 13.5 8.00065V5.66732C13.5 3.76065 12.5733 2.83398 10.6667 2.83398H5.33333C3.42667 2.83398 2.5 3.76065 2.5 5.66732V11.334C2.5 13.2407 3.42667 14.1673 5.33333 14.1673H8C8.27333 14.1673 8.5 14.394 8.5 14.6673C8.5 14.9406 8.27333 15.1673 8 15.1673Z"
        fill={color}
      />
    </svg>
  );
}
CalenderEditIcon.propTypes = {
  color: PropTypes.string,
};
CalenderEditIcon.defaultProps = {
  color: '#1D3E69',
};
export function StatusIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.666 5.83398C11.286 5.83398 10.166 4.71398 10.166 3.33398C10.166 1.95398 11.286 0.833984 12.666 0.833984C14.046 0.833984 15.166 1.95398 15.166 3.33398C15.166 4.71398 14.046 5.83398 12.666 5.83398ZM12.666 1.83398C11.8393 1.83398 11.166 2.50732 11.166 3.33398C11.166 4.16065 11.8393 4.83398 12.666 4.83398C13.4927 4.83398 14.166 4.16065 14.166 3.33398C14.166 2.50732 13.4927 1.83398 12.666 1.83398Z"
        fill={color}
      />
      <path
        d="M7.99935 9.16602H4.66602C4.39268 9.16602 4.16602 8.93935 4.16602 8.66602C4.16602 8.39268 4.39268 8.16602 4.66602 8.16602H7.99935C8.27268 8.16602 8.49935 8.39268 8.49935 8.66602C8.49935 8.93935 8.27268 9.16602 7.99935 9.16602Z"
        fill={color}
      />
      <path
        d="M10.666 11.834H4.66602C4.39268 11.834 4.16602 11.6073 4.16602 11.334C4.16602 11.0607 4.39268 10.834 4.66602 10.834H10.666C10.9393 10.834 11.166 11.0607 11.166 11.334C11.166 11.6073 10.9393 11.834 10.666 11.834Z"
        fill={color}
      />
      <path
        d="M10.0007 15.1673H6.00065C2.38065 15.1673 0.833984 13.6207 0.833984 10.0007V6.00065C0.833984 2.38065 2.38065 0.833984 6.00065 0.833984H9.33398C9.60732 0.833984 9.83398 1.06065 9.83398 1.33398C9.83398 1.60732 9.60732 1.83398 9.33398 1.83398H6.00065C2.92732 1.83398 1.83398 2.92732 1.83398 6.00065V10.0007C1.83398 13.074 2.92732 14.1673 6.00065 14.1673H10.0007C13.074 14.1673 14.1673 13.074 14.1673 10.0007V6.66732C14.1673 6.39398 14.394 6.16732 14.6673 6.16732C14.9406 6.16732 15.1673 6.39398 15.1673 6.66732V10.0007C15.1673 13.6207 13.6207 15.1673 10.0007 15.1673Z"
        fill={color}
      />
    </svg>
  );
}
StatusIcon.propTypes = {
  color: PropTypes.string,
};
StatusIcon.defaultProps = {
  color: '#1D3E69',
};
export function NotificationIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 7.01395C7.72667 7.01395 7.5 6.78728 7.5 6.51395V4.29395C7.5 4.02061 7.72667 3.79395 8 3.79395C8.27333 3.79395 8.5 4.02061 8.5 4.29395V6.51395C8.5 6.79395 8.27333 7.01395 8 7.01395Z"
        fill={color}
      />
      <path
        d="M8.01357 13.5662C6.29357 13.5662 4.58024 13.2928 2.9469 12.7462C2.34024 12.5462 1.88024 12.1128 1.68024 11.5662C1.48024 11.0195 1.5469 10.3928 1.87357 9.84617L2.72024 8.43284C2.9069 8.1195 3.07357 7.53284 3.07357 7.16617V5.76617C3.07357 3.0395 5.2869 0.826172 8.01357 0.826172C10.7402 0.826172 12.9536 3.0395 12.9536 5.76617V7.16617C12.9536 7.52617 13.1202 8.1195 13.3069 8.43284L14.1536 9.84617C14.4669 10.3662 14.5202 10.9862 14.3136 11.5528C14.1069 12.1195 13.6536 12.5528 13.0802 12.7462C11.4469 13.2995 9.73357 13.5662 8.01357 13.5662ZM8.01357 1.83284C5.84024 1.83284 4.07357 3.59951 4.07357 5.77284V7.17284C4.07357 7.71284 3.86024 8.49284 3.58024 8.95284L2.73357 10.3728C2.56024 10.6595 2.52024 10.9662 2.62024 11.2328C2.72024 11.4995 2.9469 11.6995 3.2669 11.8062C6.33357 12.8262 9.7069 12.8262 12.7736 11.8062C13.0602 11.7128 13.2802 11.4995 13.3802 11.2195C13.4869 10.9395 13.4536 10.6328 13.3002 10.3728L12.4536 8.9595C12.1736 8.4995 11.9602 7.71951 11.9602 7.17951V5.77951C11.9536 3.59951 10.1869 1.83284 8.01357 1.83284Z"
        fill={color}
      />
      <path
        d="M7.9993 15.2669C7.28596 15.2669 6.58596 14.9735 6.0793 14.4669C5.57263 13.9602 5.2793 13.2602 5.2793 12.5469H6.2793C6.2793 13.0002 6.46596 13.4402 6.78596 13.7602C7.10596 14.0802 7.54596 14.2669 7.9993 14.2669C8.94596 14.2669 9.7193 13.4935 9.7193 12.5469H10.7193C10.7193 14.0469 9.4993 15.2669 7.9993 15.2669Z"
        fill={color}
      />
    </svg>
  );
}
NotificationIcon.propTypes = {
  color: PropTypes.string,
};
NotificationIcon.defaultProps = {
  color: '#1D3E69',
};
export function Participants({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0004 15.1668H6.00042C5.12042 15.1668 4.38709 15.0802 3.76709 14.8935C3.54042 14.8268 3.39376 14.6068 3.40709 14.3735C3.57376 12.3802 5.59376 10.8135 8.00042 10.8135C10.4071 10.8135 12.4204 12.3735 12.5938 14.3735C12.6138 14.6135 12.4671 14.8268 12.2338 14.8935C11.6138 15.0802 10.8804 15.1668 10.0004 15.1668ZM4.48042 14.0402C4.92042 14.1268 5.42042 14.1668 6.00042 14.1668H10.0004C10.5804 14.1668 11.0804 14.1268 11.5204 14.0402C11.1671 12.7602 9.70709 11.8135 8.00042 11.8135C6.29376 11.8135 4.83376 12.7602 4.48042 14.0402Z"
        fill={color}
      />
      <path
        d="M10.0007 1.33398H6.00065C2.66732 1.33398 1.33398 2.66732 1.33398 6.00065V10.0007C1.33398 12.5207 2.09398 13.9006 3.90732 14.414C4.05398 12.6806 5.83398 11.314 8.00065 11.314C10.1673 11.314 11.9473 12.6806 12.094 14.414C13.9073 13.9006 14.6673 12.5207 14.6673 10.0007V6.00065C14.6673 2.66732 13.334 1.33398 10.0007 1.33398ZM8.00065 9.44731C6.68065 9.44731 5.61398 8.374 5.61398 7.054C5.61398 5.734 6.68065 4.66732 8.00065 4.66732C9.32065 4.66732 10.3873 5.734 10.3873 7.054C10.3873 8.374 9.32065 9.44731 8.00065 9.44731Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99995 9.946C6.40662 9.946 5.11328 8.64603 5.11328 7.05269C5.11328 5.45936 6.40662 4.16602 7.99995 4.16602C9.59328 4.16602 10.8866 5.45936 10.8866 7.05269C10.8866 8.64603 9.59328 9.946 7.99995 9.946ZM7.99995 5.16602C6.95995 5.16602 6.11328 6.01269 6.11328 7.05269C6.11328 8.09936 6.95995 8.946 7.99995 8.946C9.03995 8.946 9.88662 8.09936 9.88662 7.05269C9.88662 6.01269 9.03995 5.16602 7.99995 5.16602Z"
        fill={color}
      />
    </svg>
  );
}
Participants.propTypes = {
  color: PropTypes.string,
};
Participants.defaultProps = {
  color: '#1D3E69',
};
export function ApplyAllIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99967 15.1663C4.04634 15.1663 0.833008 11.953 0.833008 7.99967C0.833008 4.04634 4.04634 0.833008 7.99967 0.833008C11.953 0.833008 15.1663 4.04634 15.1663 7.99967C15.1663 11.953 11.953 15.1663 7.99967 15.1663ZM7.99967 1.83301C4.59967 1.83301 1.83301 4.59967 1.83301 7.99967C1.83301 11.3997 4.59967 14.1663 7.99967 14.1663C11.3997 14.1663 14.1663 11.3997 14.1663 7.99967C14.1663 4.59967 11.3997 1.83301 7.99967 1.83301Z"
        fill="white"
      />
      <path
        d="M7.05297 10.3867C6.91964 10.3867 6.79297 10.3334 6.69964 10.2401L4.81297 8.3534C4.61964 8.16006 4.61964 7.84007 4.81297 7.64673C5.0063 7.4534 5.3263 7.4534 5.51964 7.64673L7.05297 9.18007L10.4796 5.7534C10.673 5.56007 10.993 5.56007 11.1863 5.7534C11.3796 5.94673 11.3796 6.26673 11.1863 6.46006L7.4063 10.2401C7.31297 10.3334 7.1863 10.3867 7.05297 10.3867Z"
        fill="white"
      />
    </svg>
  );
}
export function ClearAllIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 9C7.5 10.9375 7.0415 12.784 6.5 14.5H14C14.6345 12.262 14.5 10.5415 14.5 9M7.5 9V8C7.5 7.73478 7.60536 7.48043 7.79289 7.29289C7.98043 7.10536 8.23478 7 8.5 7H13.5C13.7652 7 14.0196 7.10536 14.2071 7.29289C14.3946 7.48043 14.5 7.73478 14.5 8V9M7.5 9H14.5M11 7V1.5"
        stroke={color}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 12C12.5 12.7915 12.214 13.7045 11.7085 14.5M9.5 12C9.5 12.7915 9.214 13.7045 8.7085 14.5M2.5 10.5V12.5M1.5 11.5H3.5M4.5 6.5V8.5M3.5 7.5H5.5"
        stroke={color}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
ClearAllIcon.propTypes = {
  color: PropTypes.string,
};
ClearAllIcon.defaultProps = {
  color: '#ffffff',
};
export function ActionIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.66536 15.1663H5.9987C2.3787 15.1663 0.832031 13.6197 0.832031 9.99967V5.99967C0.832031 2.37967 2.3787 0.833008 5.9987 0.833008H9.9987C13.6187 0.833008 15.1654 2.37967 15.1654 5.99967V8.66634C15.1654 8.93967 14.9387 9.16634 14.6654 9.16634C14.392 9.16634 14.1654 8.93967 14.1654 8.66634V5.99967C14.1654 2.92634 13.072 1.83301 9.9987 1.83301H5.9987C2.92536 1.83301 1.83203 2.92634 1.83203 5.99967V9.99967C1.83203 13.073 2.92536 14.1663 5.9987 14.1663H8.66536C8.9387 14.1663 9.16536 14.393 9.16536 14.6663C9.16536 14.9397 8.9387 15.1663 8.66536 15.1663Z"
        fill={color}
      />
      <path
        d="M8.66536 15.1663H5.9987C2.3787 15.1663 0.832031 13.6197 0.832031 9.99967V5.99967C0.832031 2.37967 2.3787 0.833008 5.9987 0.833008H9.9987C13.6187 0.833008 15.1654 2.37967 15.1654 5.99967V8.66634C15.1654 8.93967 14.9387 9.16634 14.6654 9.16634C14.392 9.16634 14.1654 8.93967 14.1654 8.66634V5.99967C14.1654 2.92634 13.072 1.83301 9.9987 1.83301H5.9987C2.92536 1.83301 1.83203 2.92634 1.83203 5.99967V9.99967C1.83203 13.073 2.92536 14.1663 5.9987 14.1663H8.66536C8.9387 14.1663 9.16536 14.393 9.16536 14.6663C9.16536 14.9397 8.9387 15.1663 8.66536 15.1663Z"
        fill={color}
      />
      <path
        d="M4.66797 9.79332C4.39464 9.79332 4.16797 9.56665 4.16797 9.29332V7.15332C4.16797 6.87999 4.39464 6.65332 4.66797 6.65332C4.9413 6.65332 5.16797 6.87999 5.16797 7.15332V9.29332C5.16797 9.57332 4.9413 9.79332 4.66797 9.79332Z"
        fill={color}
      />
      <path
        d="M11.332 9.79332C11.0587 9.79332 10.832 9.56665 10.832 9.29332V7.15332C10.832 6.87999 11.0587 6.65332 11.332 6.65332C11.6054 6.65332 11.832 6.87999 11.832 7.15332V9.29332C11.832 9.57332 11.6054 9.79332 11.332 9.79332Z"
        fill={color}
      />
      <path
        d="M8.66536 15.1663H5.9987C2.3787 15.1663 0.832031 13.6197 0.832031 9.99967V5.99967C0.832031 2.37967 2.3787 0.833008 5.9987 0.833008H9.9987C13.6187 0.833008 15.1654 2.37967 15.1654 5.99967V8.66634C15.1654 8.93967 14.9387 9.16634 14.6654 9.16634C14.392 9.16634 14.1654 8.93967 14.1654 8.66634V5.99967C14.1654 2.92634 13.072 1.83301 9.9987 1.83301H5.9987C2.92536 1.83301 1.83203 2.92634 1.83203 5.99967V9.99967C1.83203 13.073 2.92536 14.1663 5.9987 14.1663H8.66536C8.9387 14.1663 9.16536 14.393 9.16536 14.6663C9.16536 14.9397 8.9387 15.1663 8.66536 15.1663Z"
        fill={color}
      />
      <path
        d="M11.7221 14.4998C11.5888 14.4998 11.4621 14.4465 11.3688 14.3532L10.3155 13.3065C10.1221 13.1132 10.1155 12.7932 10.3155 12.5998C10.5088 12.4065 10.8288 12.3998 11.0221 12.5998L11.6955 13.2665L13.6288 11.0065C13.8088 10.7932 14.1221 10.7732 14.3355 10.9532C14.5421 11.1332 14.5688 11.4465 14.3888 11.6598L12.1088 14.3265C12.0155 14.4332 11.8888 14.4932 11.7488 14.4998C11.7355 14.4998 11.7288 14.4998 11.7221 14.4998Z"
        fill={color}
      />
      <path
        d="M8 9.5C7.72667 9.5 7.5 9.27333 7.5 9V7C7.5 6.72667 7.72667 6.5 8 6.5C8.27333 6.5 8.5 6.72667 8.5 7V9C8.5 9.27333 8.27333 9.5 8 9.5Z"
        fill={color}
      />
    </svg>
  );
}
ActionIcon.propTypes = {
  color: PropTypes.string,
};
ActionIcon.defaultProps = {
  color: '#1D3E69',
};
export function OwnerIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.332 14.5H4.66536C1.72536 14.5 0.832031 13.6067 0.832031 10.6667V5.33333C0.832031 2.39333 1.72536 1.5 4.66536 1.5H11.332C14.272 1.5 15.1654 2.39333 15.1654 5.33333V10.6667C15.1654 13.6067 14.272 14.5 11.332 14.5ZM4.66536 2.5C2.2787 2.5 1.83203 2.95333 1.83203 5.33333V10.6667C1.83203 13.0467 2.2787 13.5 4.66536 13.5H11.332C13.7187 13.5 14.1654 13.0467 14.1654 10.6667V5.33333C14.1654 2.95333 13.7187 2.5 11.332 2.5H4.66536Z"
        fill={color}
      />
      <path
        d="M12.6654 5.83301H9.33203C9.0587 5.83301 8.83203 5.60634 8.83203 5.33301C8.83203 5.05967 9.0587 4.83301 9.33203 4.83301H12.6654C12.9387 4.83301 13.1654 5.05967 13.1654 5.33301C13.1654 5.60634 12.9387 5.83301 12.6654 5.83301Z"
        fill={color}
      />
      <path
        d="M12.6667 8.5H10C9.72667 8.5 9.5 8.27333 9.5 8C9.5 7.72667 9.72667 7.5 10 7.5H12.6667C12.94 7.5 13.1667 7.72667 13.1667 8C13.1667 8.27333 12.94 8.5 12.6667 8.5Z"
        fill={color}
      />
      <path
        d="M12.6654 11.167H11.332C11.0587 11.167 10.832 10.9403 10.832 10.667C10.832 10.3937 11.0587 10.167 11.332 10.167H12.6654C12.9387 10.167 13.1654 10.3937 13.1654 10.667C13.1654 10.9403 12.9387 11.167 12.6654 11.167Z"
        fill={color}
      />
      <path
        d="M5.6676 8.02661C4.7276 8.02661 3.96094 7.25995 3.96094 6.31995C3.96094 5.37995 4.7276 4.61328 5.6676 4.61328C6.6076 4.61328 7.37427 5.37995 7.37427 6.31995C7.37427 7.25995 6.6076 8.02661 5.6676 8.02661ZM5.6676 5.61328C5.28094 5.61328 4.96094 5.93328 4.96094 6.31995C4.96094 6.70661 5.28094 7.02661 5.6676 7.02661C6.05427 7.02661 6.37427 6.70661 6.37427 6.31995C6.37427 5.93328 6.05427 5.61328 5.6676 5.61328Z"
        fill={color}
      />
      <path
        d="M7.99994 11.3862C7.7466 11.3862 7.5266 11.1929 7.49994 10.9329C7.4266 10.2129 6.8466 9.63285 6.11994 9.56619C5.81327 9.53952 5.5066 9.53952 5.19994 9.56619C4.47327 9.63285 3.89327 10.2062 3.81994 10.9329C3.79327 11.2062 3.5466 11.4129 3.27327 11.3795C2.99994 11.3529 2.79994 11.1062 2.8266 10.8329C2.9466 9.63285 3.89994 8.67952 5.1066 8.57285C5.47327 8.53952 5.8466 8.53952 6.21327 8.57285C7.41327 8.68618 8.37327 9.63952 8.49327 10.8329C8.51994 11.1062 8.31994 11.3529 8.0466 11.3795C8.03327 11.3862 8.01327 11.3862 7.99994 11.3862Z"
        fill={color}
      />
    </svg>
  );
}
OwnerIcon.propTypes = {
  color: PropTypes.string,
};
OwnerIcon.defaultProps = {
  color: '#1D3E69',
};
export function ModeIcons({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.67448 4.33333C3.30781 4.33333 3.00781 4.03333 3.00781 3.66667C3.00781 3.3 3.30115 3 3.67448 3H3.68115C4.04781 3 4.34781 3.3 4.34781 3.66667C4.34781 4.03333 4.04781 4.33333 3.67448 4.33333Z"
        fill={color}
      />
      <path
        d="M12.3424 13.0003C11.9758 13.0003 11.6758 12.7003 11.6758 12.3337C11.6758 11.967 11.9691 11.667 12.3424 11.667H12.3491C12.7158 11.667 13.0158 11.967 13.0158 12.3337C13.0158 12.7003 12.7158 13.0003 12.3424 13.0003Z"
        fill={color}
      />
      <path
        d="M3.64583 6.49967C2.08583 6.49967 0.8125 5.22634 0.8125 3.66634C0.8125 2.10634 2.08583 0.833008 3.64583 0.833008C5.20583 0.833008 6.47917 2.10634 6.47917 3.66634C6.47917 5.22634 5.2125 6.49967 3.64583 6.49967ZM3.64583 1.83301C2.6325 1.83301 1.8125 2.65301 1.8125 3.66634C1.8125 4.67967 2.6325 5.49967 3.64583 5.49967C4.65917 5.49967 5.47917 4.67967 5.47917 3.66634C5.47917 2.65301 4.65917 1.83301 3.64583 1.83301Z"
        fill={color}
      />
      <path
        d="M13.3138 15.1667H11.3138C10.3005 15.1667 9.48047 14.3467 9.48047 13.3333V11.3333C9.48047 10.32 10.3005 9.5 11.3138 9.5H13.3138C14.3271 9.5 15.1471 10.32 15.1471 11.3333V13.3333C15.1471 14.3467 14.3271 15.1667 13.3138 15.1667ZM11.3138 10.5C10.8538 10.5 10.4805 10.8733 10.4805 11.3333V13.3333C10.4805 13.7933 10.8538 14.1667 11.3138 14.1667H13.3138C13.7738 14.1667 14.1471 13.7933 14.1471 13.3333V11.3333C14.1471 10.8733 13.7738 10.5 13.3138 10.5H11.3138Z"
        fill={color}
      />
      <path
        d="M7.99963 13.1663H6.21297C5.43963 13.1663 4.7663 12.6997 4.49963 11.9797C4.2263 11.2597 4.4263 10.4663 5.0063 9.95301L10.333 5.29301C10.653 5.01301 10.6596 4.63301 10.5663 4.37301C10.4663 4.11301 10.213 3.83301 9.7863 3.83301H7.99963C7.7263 3.83301 7.49963 3.60634 7.49963 3.33301C7.49963 3.05967 7.7263 2.83301 7.99963 2.83301H9.7863C10.5596 2.83301 11.233 3.29967 11.4996 4.01967C11.773 4.73967 11.573 5.53301 10.993 6.04634L5.6663 10.7063C5.3463 10.9863 5.33963 11.3663 5.43297 11.6263C5.53297 11.8863 5.7863 12.1663 6.21297 12.1663H7.99963C8.27297 12.1663 8.49963 12.393 8.49963 12.6663C8.49963 12.9397 8.27297 13.1663 7.99963 13.1663Z"
        fill={color}
      />
    </svg>
  );
}
ModeIcons.propTypes = {
  color: PropTypes.string,
};
ModeIcons.defaultProps = {
  color: '#1D3E69',
};
export function ForwarderIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.66782 9.83301H8.00115C7.72782 9.83301 7.50115 9.60634 7.50115 9.33301C7.50115 9.05967 7.72782 8.83301 8.00115 8.83301H8.66782C9.12782 8.83301 9.50115 8.45967 9.50115 7.99967V1.83301H4.00115C3.21449 1.83301 2.49447 2.25966 2.1078 2.94633C1.97447 3.18633 1.66783 3.27302 1.42783 3.13969C1.18783 3.00636 1.10114 2.69968 1.23447 2.45968C1.79447 1.45968 2.85449 0.833008 4.00115 0.833008H10.0012C10.2745 0.833008 10.5012 1.05967 10.5012 1.33301V7.99967C10.5012 9.01301 9.68115 9.83301 8.66782 9.83301Z"
        fill={color}
      />
      <path
        d="M12.6654 13.833H11.9987C11.7254 13.833 11.4987 13.6063 11.4987 13.333C11.4987 12.873 11.1254 12.4997 10.6654 12.4997C10.2054 12.4997 9.83203 12.873 9.83203 13.333C9.83203 13.6063 9.60536 13.833 9.33203 13.833H6.66536C6.39203 13.833 6.16536 13.6063 6.16536 13.333C6.16536 12.873 5.79203 12.4997 5.33203 12.4997C4.87203 12.4997 4.4987 12.873 4.4987 13.333C4.4987 13.6063 4.27203 13.833 3.9987 13.833H3.33203C1.95203 13.833 0.832031 12.713 0.832031 11.333C0.832031 11.0597 1.0587 10.833 1.33203 10.833C1.60536 10.833 1.83203 11.0597 1.83203 11.333C1.83203 12.1597 2.50536 12.833 3.33203 12.833H3.56535C3.78535 12.0663 4.49203 11.4997 5.33203 11.4997C6.17203 11.4997 6.87871 12.0663 7.09871 12.833H8.90535C9.12535 12.0663 9.83204 11.4997 10.672 11.4997C11.512 11.4997 12.2187 12.0663 12.4387 12.833H12.6654C13.492 12.833 14.1654 12.1597 14.1654 11.333V9.83301H12.6654C12.0254 9.83301 11.4987 9.30634 11.4987 8.66634V6.66634C11.4987 6.02634 12.0187 5.49967 12.6654 5.49967L11.952 4.25301C11.8054 3.99301 11.5254 3.83301 11.2254 3.83301H10.4987V7.99967C10.4987 9.01301 9.6787 9.83301 8.66536 9.83301H7.9987C7.72536 9.83301 7.4987 9.60634 7.4987 9.33301C7.4987 9.05967 7.72536 8.83301 7.9987 8.83301H8.66536C9.12536 8.83301 9.4987 8.45967 9.4987 7.99967V3.33301C9.4987 3.05967 9.72536 2.83301 9.9987 2.83301H11.2254C11.8854 2.83301 12.492 3.18635 12.8187 3.75968L13.9587 5.75301C14.0454 5.90634 14.0454 6.09968 13.9587 6.25301C13.872 6.40634 13.7053 6.49967 13.5253 6.49967H12.6654C12.572 6.49967 12.4987 6.57301 12.4987 6.66634V8.66634C12.4987 8.75967 12.572 8.83301 12.6654 8.83301H14.6654C14.9387 8.83301 15.1654 9.05967 15.1654 9.33301V11.333C15.1654 12.713 14.0454 13.833 12.6654 13.833Z"
        fill={color}
      />
      <path
        d="M5.33333 15.1667C4.32 15.1667 3.5 14.3467 3.5 13.3333C3.5 12.32 4.32 11.5 5.33333 11.5C6.34667 11.5 7.16667 12.32 7.16667 13.3333C7.16667 14.3467 6.34667 15.1667 5.33333 15.1667ZM5.33333 12.5C4.87333 12.5 4.5 12.8733 4.5 13.3333C4.5 13.7933 4.87333 14.1667 5.33333 14.1667C5.79333 14.1667 6.16667 13.7933 6.16667 13.3333C6.16667 12.8733 5.79333 12.5 5.33333 12.5Z"
        fill={color}
      />
      <path
        d="M10.6654 15.1667C9.65203 15.1667 8.83203 14.3467 8.83203 13.3333C8.83203 12.32 9.65203 11.5 10.6654 11.5C11.6787 11.5 12.4987 12.32 12.4987 13.3333C12.4987 14.3467 11.6787 15.1667 10.6654 15.1667ZM10.6654 12.5C10.2054 12.5 9.83203 12.8733 9.83203 13.3333C9.83203 13.7933 10.2054 14.1667 10.6654 14.1667C11.1254 14.1667 11.4987 13.7933 11.4987 13.3333C11.4987 12.8733 11.1254 12.5 10.6654 12.5Z"
        fill={color}
      />
      <path
        d="M14.6667 9.83333H12.6667C12.0267 9.83333 11.5 9.30667 11.5 8.66667V6.66667C11.5 6.02667 12.0267 5.5 12.6667 5.5H13.5267C13.7067 5.5 13.8733 5.59334 13.96 5.75334L15.1 7.75334C15.14 7.82667 15.1667 7.91333 15.1667 8V9.33333C15.1667 9.60667 14.94 9.83333 14.6667 9.83333ZM12.6667 6.5C12.5733 6.5 12.5 6.57333 12.5 6.66667V8.66667C12.5 8.76 12.5733 8.83333 12.6667 8.83333H14.1667V8.13334L13.2333 6.5H12.6667Z"
        fill={color}
      />
      <path
        d="M5.33203 5.83301H1.33203C1.0587 5.83301 0.832031 5.60634 0.832031 5.33301C0.832031 5.05967 1.0587 4.83301 1.33203 4.83301H5.33203C5.60536 4.83301 5.83203 5.05967 5.83203 5.33301C5.83203 5.60634 5.60536 5.83301 5.33203 5.83301Z"
        fill={color}
      />
      <path
        d="M3.9987 7.83301H1.33203C1.0587 7.83301 0.832031 7.60634 0.832031 7.33301C0.832031 7.05967 1.0587 6.83301 1.33203 6.83301H3.9987C4.27203 6.83301 4.4987 7.05967 4.4987 7.33301C4.4987 7.60634 4.27203 7.83301 3.9987 7.83301Z"
        fill={color}
      />
      <path
        d="M2.66536 9.83301H1.33203C1.0587 9.83301 0.832031 9.60634 0.832031 9.33301C0.832031 9.05967 1.0587 8.83301 1.33203 8.83301H2.66536C2.9387 8.83301 3.16536 9.05967 3.16536 9.33301C3.16536 9.60634 2.9387 9.83301 2.66536 9.83301Z"
        fill={color}
      />
    </svg>
  );
}
ForwarderIcon.propTypes = {
  color: PropTypes.string,
};
ForwarderIcon.defaultProps = {
  color: '#1D3E69',
};
export function ETAIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33203 3.83301C5.0587 3.83301 4.83203 3.60634 4.83203 3.33301V1.33301C4.83203 1.05967 5.0587 0.833008 5.33203 0.833008C5.60536 0.833008 5.83203 1.05967 5.83203 1.33301V3.33301C5.83203 3.60634 5.60536 3.83301 5.33203 3.83301Z"
        fill={color}
      />
      <path
        d="M10.668 3.83301C10.3946 3.83301 10.168 3.60634 10.168 3.33301V1.33301C10.168 1.05967 10.3946 0.833008 10.668 0.833008C10.9413 0.833008 11.168 1.05967 11.168 1.33301V3.33301C11.168 3.60634 10.9413 3.83301 10.668 3.83301Z"
        fill={color}
      />
      <path
        d="M5.66667 9.66655C5.58 9.66655 5.49333 9.64656 5.41333 9.61322C5.32667 9.57989 5.26 9.53321 5.19333 9.47321C5.07333 9.34654 5 9.17988 5 8.99988C5 8.91322 5.02 8.82655 5.05333 8.74655C5.08667 8.66655 5.13333 8.59322 5.19333 8.52655C5.26 8.46655 5.32667 8.41987 5.41333 8.38654C5.65333 8.28654 5.95333 8.33989 6.14 8.52655C6.26 8.65322 6.33333 8.82655 6.33333 8.99988C6.33333 9.03988 6.32667 9.08656 6.32 9.13322C6.31333 9.17322 6.3 9.21322 6.28 9.25322C6.26667 9.29322 6.24667 9.33321 6.22 9.37321C6.2 9.40655 6.16667 9.43988 6.14 9.47321C6.01333 9.59321 5.84 9.66655 5.66667 9.66655Z"
        fill={color}
      />
      <path
        d="M7.9987 9.66658C7.91203 9.66658 7.82536 9.64659 7.74536 9.61326C7.6587 9.57992 7.59203 9.53324 7.52537 9.47324C7.40537 9.34658 7.33203 9.17992 7.33203 8.99992C7.33203 8.91325 7.35203 8.82658 7.38537 8.74658C7.4187 8.66658 7.46537 8.59325 7.52537 8.52659C7.59203 8.46659 7.6587 8.41991 7.74536 8.38657C7.98536 8.27991 8.28536 8.33992 8.47203 8.52659C8.59203 8.65325 8.66536 8.82658 8.66536 8.99992C8.66536 9.03992 8.6587 9.08659 8.65203 9.13326C8.64536 9.17326 8.63203 9.21325 8.61203 9.25325C8.5987 9.29325 8.5787 9.33325 8.55203 9.37325C8.53203 9.40658 8.4987 9.43991 8.47203 9.47324C8.34536 9.59324 8.17203 9.66658 7.9987 9.66658Z"
        fill={color}
      />
      <path
        d="M10.3346 9.66658C10.248 9.66658 10.1613 9.64659 10.0813 9.61326C9.99463 9.57992 9.92797 9.53324 9.8613 9.47324C9.83464 9.43991 9.80797 9.40658 9.7813 9.37325C9.75463 9.33325 9.73464 9.29325 9.7213 9.25325C9.7013 9.21325 9.68797 9.17326 9.6813 9.13326C9.67464 9.08659 9.66797 9.03992 9.66797 8.99992C9.66797 8.82658 9.7413 8.65325 9.8613 8.52659C9.92797 8.46659 9.99463 8.41991 10.0813 8.38657C10.328 8.27991 10.6213 8.33992 10.808 8.52659C10.928 8.65325 11.0013 8.82658 11.0013 8.99992C11.0013 9.03992 10.9946 9.08659 10.988 9.13326C10.9813 9.17326 10.968 9.21325 10.948 9.25325C10.9346 9.29325 10.9146 9.33325 10.888 9.37325C10.868 9.40658 10.8346 9.43991 10.808 9.47324C10.6813 9.59324 10.508 9.66658 10.3346 9.66658Z"
        fill={color}
      />
      <path
        d="M5.66667 11.9998C5.58 11.9998 5.49333 11.9798 5.41333 11.9465C5.33333 11.9131 5.26 11.8665 5.19333 11.8065C5.07333 11.6798 5 11.5065 5 11.3331C5 11.2465 5.02 11.1598 5.05333 11.0798C5.08667 10.9931 5.13333 10.9198 5.19333 10.8598C5.44 10.6131 5.89333 10.6131 6.14 10.8598C6.26 10.9865 6.33333 11.1598 6.33333 11.3331C6.33333 11.5065 6.26 11.6798 6.14 11.8065C6.01333 11.9265 5.84 11.9998 5.66667 11.9998Z"
        fill={color}
      />
      <path
        d="M7.9987 11.9998C7.82536 11.9998 7.65203 11.9265 7.52537 11.8065C7.40537 11.6798 7.33203 11.5065 7.33203 11.3331C7.33203 11.2465 7.35203 11.1598 7.38537 11.0798C7.4187 10.9931 7.46537 10.9198 7.52537 10.8598C7.77203 10.6131 8.22536 10.6131 8.47203 10.8598C8.53203 10.9198 8.5787 10.9931 8.61203 11.0798C8.64536 11.1598 8.66536 11.2465 8.66536 11.3331C8.66536 11.5065 8.59203 11.6798 8.47203 11.8065C8.34536 11.9265 8.17203 11.9998 7.9987 11.9998Z"
        fill={color}
      />
      <path
        d="M10.3346 11.9999C10.1613 11.9999 9.98797 11.9266 9.8613 11.8066C9.8013 11.7466 9.75464 11.6733 9.7213 11.5866C9.68797 11.5066 9.66797 11.4199 9.66797 11.3333C9.66797 11.2466 9.68797 11.1599 9.7213 11.0799C9.75464 10.9933 9.8013 10.9199 9.8613 10.8599C10.0146 10.7066 10.248 10.6333 10.4613 10.6799C10.508 10.6866 10.548 10.6999 10.588 10.7199C10.628 10.7333 10.668 10.7533 10.708 10.78C10.7413 10.8 10.7746 10.8333 10.808 10.8599C10.928 10.9866 11.0013 11.1599 11.0013 11.3333C11.0013 11.5066 10.928 11.6799 10.808 11.8066C10.6813 11.9266 10.508 11.9999 10.3346 11.9999Z"
        fill={color}
      />
      <path
        d="M13.6654 6.55957H2.33203C2.0587 6.55957 1.83203 6.3329 1.83203 6.05957C1.83203 5.78624 2.0587 5.55957 2.33203 5.55957H13.6654C13.9387 5.55957 14.1654 5.78624 14.1654 6.05957C14.1654 6.3329 13.9387 6.55957 13.6654 6.55957Z"
        fill={color}
      />
      <path
        d="M10.6667 15.1663H5.33333C2.9 15.1663 1.5 13.7663 1.5 11.333V5.66634C1.5 3.23301 2.9 1.83301 5.33333 1.83301H10.6667C13.1 1.83301 14.5 3.23301 14.5 5.66634V11.333C14.5 13.7663 13.1 15.1663 10.6667 15.1663ZM5.33333 2.83301C3.42667 2.83301 2.5 3.75967 2.5 5.66634V11.333C2.5 13.2397 3.42667 14.1663 5.33333 14.1663H10.6667C12.5733 14.1663 13.5 13.2397 13.5 11.333V5.66634C13.5 3.75967 12.5733 2.83301 10.6667 2.83301H5.33333Z"
        fill={color}
      />
    </svg>
  );
}
ETAIcon.propTypes = {
  color: PropTypes.string,
};
ETAIcon.defaultProps = {
  color: '#1D3E69',
};
export function EventIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.66536 9.83366H1.33203C1.0587 9.83366 0.832031 9.60699 0.832031 9.33366V5.08032C0.832031 4.86699 0.965358 4.68031 1.15869 4.60697C1.35869 4.53364 1.5787 4.59366 1.71204 4.75366C2.1187 5.24033 2.75204 5.51365 3.3787 5.49365C3.91204 5.48032 4.40535 5.28034 4.77869 4.927C4.95202 4.78034 5.09202 4.60699 5.19869 4.41366C5.40536 4.06032 5.50536 3.67365 5.4987 3.28031C5.48536 2.66698 5.21871 2.10698 4.76538 1.70032C4.60538 1.56032 4.55203 1.34031 4.62537 1.14697C4.6987 0.953639 4.88537 0.820312 5.09204 0.820312H9.9987C10.272 0.820312 10.4987 1.04698 10.4987 1.32031V7.98698C10.4987 9.01365 9.6787 9.83366 8.66536 9.83366ZM1.83203 8.83366H8.66536C9.12537 8.83366 9.4987 8.46033 9.4987 8.00033V1.83366H6.12537C6.3587 2.26699 6.48536 2.75367 6.4987 3.26034C6.51203 3.84034 6.36536 4.41366 6.07202 4.91366C5.91202 5.20032 5.69203 5.47367 5.45203 5.67367C4.91869 6.18033 4.18535 6.48033 3.40535 6.50033C2.85202 6.52033 2.30537 6.38033 1.8387 6.12699V8.83366H1.83203Z"
        fill={color}
      />
      <path
        d="M12.6654 13.833H11.9987C11.7254 13.833 11.4987 13.6063 11.4987 13.333C11.4987 12.873 11.1254 12.4997 10.6654 12.4997C10.2054 12.4997 9.83203 12.873 9.83203 13.333C9.83203 13.6063 9.60536 13.833 9.33203 13.833H6.66536C6.39203 13.833 6.16536 13.6063 6.16536 13.333C6.16536 12.873 5.79203 12.4997 5.33203 12.4997C4.87203 12.4997 4.4987 12.873 4.4987 13.333C4.4987 13.6063 4.27203 13.833 3.9987 13.833H3.33203C1.95203 13.833 0.832031 12.713 0.832031 11.333V9.33301C0.832031 9.05967 1.0587 8.83301 1.33203 8.83301H8.66536C9.12536 8.83301 9.4987 8.45967 9.4987 7.99967V3.33301C9.4987 3.05967 9.72536 2.83301 9.9987 2.83301H11.2254C11.8854 2.83301 12.492 3.18635 12.8187 3.75968L13.9587 5.75301C14.0454 5.90634 14.0454 6.09968 13.9587 6.25301C13.872 6.40634 13.7053 6.49967 13.5253 6.49967H12.6654C12.572 6.49967 12.4987 6.57301 12.4987 6.66634V8.66634C12.4987 8.75967 12.572 8.83301 12.6654 8.83301H14.6654C14.9387 8.83301 15.1654 9.05967 15.1654 9.33301V11.333C15.1654 12.713 14.0454 13.833 12.6654 13.833ZM12.432 12.833H12.6654C13.492 12.833 14.1654 12.1597 14.1654 11.333V9.83301H12.6654C12.0254 9.83301 11.4987 9.30634 11.4987 8.66634V6.66634C11.4987 6.02634 12.0187 5.49967 12.6654 5.49967L11.952 4.25301C11.8054 3.99301 11.5254 3.83301 11.2254 3.83301H10.4987V7.99967C10.4987 9.01301 9.6787 9.83301 8.66536 9.83301H1.83203V11.333C1.83203 12.1597 2.50536 12.833 3.33203 12.833H3.56535C3.78535 12.0663 4.49203 11.4997 5.33203 11.4997C6.17203 11.4997 6.87871 12.0663 7.09871 12.833H8.90535C9.12535 12.0663 9.83204 11.4997 10.672 11.4997C11.512 11.4997 12.212 12.0663 12.432 12.833Z"
        fill={color}
      />
      <path
        d="M5.33333 15.1667C4.32 15.1667 3.5 14.3467 3.5 13.3333C3.5 12.32 4.32 11.5 5.33333 11.5C6.34667 11.5 7.16667 12.32 7.16667 13.3333C7.16667 14.3467 6.34667 15.1667 5.33333 15.1667ZM5.33333 12.5C4.87333 12.5 4.5 12.8733 4.5 13.3333C4.5 13.7933 4.87333 14.1667 5.33333 14.1667C5.79333 14.1667 6.16667 13.7933 6.16667 13.3333C6.16667 12.8733 5.79333 12.5 5.33333 12.5Z"
        fill={color}
      />
      <path
        d="M10.6654 15.1667C9.65203 15.1667 8.83203 14.3467 8.83203 13.3333C8.83203 12.32 9.65203 11.5 10.6654 11.5C11.6787 11.5 12.4987 12.32 12.4987 13.3333C12.4987 14.3467 11.6787 15.1667 10.6654 15.1667ZM10.6654 12.5C10.2054 12.5 9.83203 12.8733 9.83203 13.3333C9.83203 13.7933 10.2054 14.1667 10.6654 14.1667C11.1254 14.1667 11.4987 13.7933 11.4987 13.3333C11.4987 12.8733 11.1254 12.5 10.6654 12.5Z"
        fill={color}
      />
      <path
        d="M14.6667 9.83333H12.6667C12.0267 9.83333 11.5 9.30667 11.5 8.66667V6.66667C11.5 6.02667 12.0267 5.5 12.6667 5.5H13.5267C13.7067 5.5 13.8733 5.59334 13.96 5.75334L15.1 7.75334C15.14 7.82667 15.1667 7.91333 15.1667 8V9.33333C15.1667 9.60667 14.94 9.83333 14.6667 9.83333ZM12.6667 6.5C12.5733 6.5 12.5 6.57333 12.5 6.66667V8.66667C12.5 8.76 12.5733 8.83333 12.6667 8.83333H14.1667V8.13334L13.2333 6.5H12.6667Z"
        fill={color}
      />
      <path
        d="M3.33464 6.50033C1.58797 6.50033 0.167969 5.08033 0.167969 3.33366C0.167969 2.36033 0.601322 1.46031 1.35466 0.860311C1.91465 0.413644 2.6213 0.166992 3.33464 0.166992C5.0813 0.166992 6.5013 1.58699 6.5013 3.33366C6.5013 4.24033 6.10797 5.10699 5.42131 5.70699C4.84131 6.22032 4.1013 6.50033 3.33464 6.50033ZM3.33464 1.16699C2.8413 1.16699 2.37462 1.33364 1.98128 1.64697C1.46795 2.05364 1.16797 2.67366 1.16797 3.33366C1.16797 4.52699 2.1413 5.50033 3.33464 5.50033C3.85464 5.50033 4.36132 5.30699 4.76799 4.96033C5.23465 4.54699 5.5013 3.96033 5.5013 3.33366C5.5013 2.14033 4.52797 1.16699 3.33464 1.16699Z"
        fill={color}
      />
      <path
        d="M2.66529 4.5C2.49863 4.5 2.33195 4.41334 2.23862 4.26001C2.09862 4.02001 2.17196 3.71332 2.41196 3.57332L3.0053 3.22001V2.5C3.0053 2.22667 3.23197 2 3.5053 2C3.77863 2 4.0053 2.22667 4.0053 2.5V3.5C4.0053 3.67333 3.91198 3.84001 3.76531 3.92668L2.93198 4.42668C2.83864 4.48001 2.75196 4.5 2.66529 4.5Z"
        fill={color}
      />
    </svg>
  );
}
EventIcon.propTypes = {
  color: PropTypes.string,
};
EventIcon.defaultProps = {
  color: '#1D3E69',
};
export function CrossIcon({ color }) {
  return (
    <svg
      width="0.833vw"
      height="0.833vw"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
        fill={color}
      />
    </svg>
  );
}
CrossIcon.propTypes = {
  color: PropTypes.string,
};
CrossIcon.defaultProps = {
  color: '#2179C4',
};
export function QuestionMark() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 5.75C9.3787 5.75 8.875 6.25368 8.875 6.875C8.875 7.28921 8.5392 7.625 8.125 7.625C7.71079 7.625 7.375 7.28921 7.375 6.875C7.375 5.42525 8.5503 4.25 10 4.25C11.4497 4.25 12.625 5.42525 12.625 6.875C12.625 7.58584 12.3415 8.232 11.883 8.704C11.7907 8.7989 11.7027 8.8869 11.6187 8.9708C11.4029 9.1864 11.2138 9.3753 11.0479 9.5885C10.8289 9.8699 10.75 10.0768 10.75 10.25V11C10.75 11.4142 10.4142 11.75 10 11.75C9.5858 11.75 9.25 11.4142 9.25 11V10.25C9.25 9.5948 9.555 9.0644 9.8642 8.6672C10.0929 8.3733 10.3804 8.0863 10.6138 7.85346C10.6842 7.78321 10.7496 7.71789 10.807 7.65877C11.0046 7.45543 11.125 7.18004 11.125 6.875C11.125 6.25368 10.6213 5.75 10 5.75ZM10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.4477 13 9 13.4477 9 14C9 14.5523 9.4477 15 10 15Z"
        fill="url(#paint0_linear_25450_94569)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_25450_94569"
          x1="20"
          y1="0.92437"
          x2="-1.70977"
          y2="19.1144"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function MaterialGroupIcon({ color }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99997 8.86665C7.91331 8.86665 7.82664 8.84665 7.74664 8.79999L1.85997 5.39332C1.62664 5.25332 1.53997 4.94665 1.67997 4.70665C1.81997 4.46665 2.12664 4.38665 2.36664 4.52665L7.99997 7.78665L13.6 4.54665C13.84 4.40665 14.1466 4.49332 14.2866 4.72665C14.4266 4.96665 14.34 5.27332 14.1066 5.41332L8.25997 8.79999C8.17331 8.83999 8.08664 8.86665 7.99997 8.86665Z"
        fill={color}
      />
      <path
        d="M8 14.9067C7.72667 14.9067 7.5 14.68 7.5 14.4067V8.35999C7.5 8.08665 7.72667 7.85999 8 7.85999C8.27333 7.85999 8.5 8.08665 8.5 8.35999V14.4067C8.5 14.68 8.27333 14.9067 8 14.9067Z"
        fill={color}
      />
      <path
        d="M7.99993 15.1667C7.41326 15.1667 6.83326 15.04 6.37326 14.7867L2.81326 12.8067C1.84659 12.2734 1.09326 10.9867 1.09326 9.88004V6.11337C1.09326 5.00671 1.84659 3.72671 2.81326 3.18671L6.37326 1.21337C7.2866 0.706707 8.71326 0.706707 9.62659 1.21337L13.1866 3.19337C14.1533 3.72671 14.9066 5.01337 14.9066 6.12004V9.88671C14.9066 10.9934 14.1533 12.2734 13.1866 12.8134L9.62659 14.7867C9.16659 15.04 8.5866 15.1667 7.99993 15.1667ZM7.99993 1.83337C7.57993 1.83337 7.16659 1.92004 6.85993 2.08671L3.29993 4.06671C2.65993 4.42004 2.09326 5.38004 2.09326 6.11337V9.88004C2.09326 10.6134 2.65993 11.5734 3.29993 11.9334L6.85993 13.9134C7.4666 14.2534 8.53326 14.2534 9.13993 13.9134L12.6999 11.9334C13.3399 11.5734 13.9066 10.62 13.9066 9.88004V6.11337C13.9066 5.38004 13.3399 4.42004 12.6999 4.06004L9.13993 2.08004C8.83326 1.92004 8.41993 1.83337 7.99993 1.83337Z"
        fill={color}
      />
    </svg>
  );
}
MaterialGroupIcon.propTypes = {
  color: PropTypes.string,
};
MaterialGroupIcon.defaultProps = {
  color: '#1D3E69',
};
